<template lang="pug">
#app
  router-view
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import "./assets/scss/style";
@import "./assets/scss/extensions";
</style>
